<button
  type="button"
  class="btn clear-disable"
  [ngClass]="{ 'fake-disable': disabled }"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="disabled ? null : singleSelectMenu"
  [craftHtmlTooltip]="companyInfoTooltip"
  [craftHtmlTooltipContext]="{ company: selectedCompany }"
  [craftHtmlTooltipPosition]="'above'"
  [craftHtmlTooltipShowDelay]="300"
  [craftHtmlTooltipHideDelay]="200"
>
  <span class="ellipsis">
    {{ selectedCompany?.name || ('company.select' | craftTerm) }}
  </span>
  <craft-icon class="svg-icon text-size-12" name="arrows--arrow-head-down-sm"></craft-icon>
</button>

<ng-template #companyInfoTooltip let-company="company">
  <craft-company-info-tooltip [company]="company"></craft-company-info-tooltip>
</ng-template>

<mat-menu #singleSelectMenu="matMenu" class="craft-companies-select-menu">
  <ng-template matMenuContent="">
    @if (hasSearch) {
      <div class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
        <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
        <input
          type="text"
          #searchInput
          (click)="$event.stopPropagation()"
          [placeholder]="searchPlaceholder"
          [formControl]="searchControl"
        />
      </div>
    }
    @if (filteredItems | async; as filteredItems) {
      <cdk-virtual-scroll-viewport
        #viewport
        [itemSize]="ROW_HEIGHT"
        class="menu-scroll menu-content"
        [style.height]="min(ROW_HEIGHT * filteredItems.length, 400) + 'px'"
      >
        <button
          *cdkVirtualFor="let item of filteredItems; trackBy: identify"
          mat-menu-item=""
          [ngClass]="{ selected: selectedId === item.id }"
          (click)="selectItem(item); menuTrigger.closeMenu()"
          craftDisableFocus=""
          type="button"
        >
          {{ item.name }}
        </button>
      </cdk-virtual-scroll-viewport>
    }
  </ng-template>
</mat-menu>
